"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merge_1 = __importDefault(require("lodash/merge"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TOOLTIP_POINTER_ARROW_SIZE = 10;
const TooltipBody = styled_components_1.default.span(({ withAutoPositioning, theme }) => {
    var _a;
    return (0, merge_1.default)({}, theme.tooltip, Object.assign({}, (withAutoPositioning
        ? Object.assign({ top: '', left: 'auto', lineHeight: 1, ':after': {
                display: 'none',
            }, transform: 'none', 
            // NOTE: We should calculate position to the top of the feature icon.
            bottom: `calc(100% + ${TOOLTIP_POINTER_ARROW_SIZE}px)` }, (((_a = theme.customTooltip) === null || _a === void 0 ? void 0 : _a.body) || {})) : {})));
});
const TooltipArrow = styled_components_1.default.span(({ theme }) => {
    var _a;
    return (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({ left: '50%', top: '-1px', width: `${TOOLTIP_POINTER_ARROW_SIZE}px`, height: `${TOOLTIP_POINTER_ARROW_SIZE}px`, display: 'block', position: 'absolute', visibility: 'hidden', transform: 'translateX(-50%)', ':after': {
            content: "''",
            width: '0',
            height: '0',
            borderStyle: 'solid',
            borderWidth: '10px 7px 0 7px',
            borderColor: 'white transparent transparent transparent',
            position: 'absolute',
            bottom: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
        } }, (((_a = theme.customTooltip) === null || _a === void 0 ? void 0 : _a.arrow) || {})));
});
const Tooltip = ({ className, testId, tooltipElRef, withAutoPositioning, children }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TooltipBody, { className: `tooltip ${className}`, ref: tooltipElRef, "data-id": testId, withAutoPositioning: withAutoPositioning }, children),
        react_1.default.createElement(TooltipArrow, { className: "tooltipArrow" })));
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map